// removed by extract-text-webpack-plugin
module.exports = {"root":"_2D8T3","appear":"C8ZS2","appear-active":"_2egK_","enter":"_3PQiL","enter-active":"_1PaXj","leave":"_3w1Kv","leave-active":"_1tPPr","footerWrapper":"_2HG3Q"};


//////////////////
// WEBPACK FOOTER
// ../source/views/Switch/styles.css
// module id = 1225
// module chunks = 26